
import SearchItem from '~/search/search-item';
import { getTypeTags } from './facility-tags';
import {
  serviceTypeToType,
  typeToService,
  typeToIcon } from './facility-types';

export default class Facility {
  constructor (type, id, floor, icon) {
    this.type = type;
    this.id = id; // in-house id's are numbers actually but this works
    this.title = `service.${typeToService(type)}`;
    this.icon = icon || typeToIcon(type);
    this.floor = floor;
  }

  static of ({ type, id, floor, icon }) {
    return new Facility(type, id, floor, icon);
  }
}

// serviceLocationToFacility :: [Floor] -> ServiceLocation -> Facility|void
export const serviceLocationToFacility = floors => serviceLocation => {
  const { id, serviceType, floorIndex } = serviceLocation;
  const type = serviceTypeToType(serviceType);
  const { id: floorId } = floors[floorIndex] || {};
  return type && new Facility(
    type,
    id,
    floorId
  );
};

// serviceLocationToSearchItem :: ServiceLocation -> SearchItem|void
export const serviceLocationToSearchItem = serviceLocation => {
  const { id, serviceType } = serviceLocation;
  const type = serviceTypeToType(serviceType);
  return type && new SearchItem(
    id,
    type,
    getTypeTags(type),
    []
  );
};
